// src/ga/index.js
import ReactGA from "react-ga4";

const initGA = () => {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID ?? ""); // Replace with your Measurement ID
};

const logPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

const sendCustomEvents = (category, action, label) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};

export { initGA, logPageView, sendCustomEvents };
